import { CircleProgress } from "components/Common/CircleProgress";
import {
  useStudentProgress,
  useStudentProgressByType,
} from "hooks/api/student-progress";
import { EExerciseType } from "types/app/exercises/common";
import "./Progress.styles.scss";

const EXERCISE_TYPE_LABELS: Partial<Record<EExerciseType, string>> = {
  [EExerciseType.ESSAY]: "Твір / текст",
  [EExerciseType.TEST]: "Варіант відповіді",
  [EExerciseType.TRUE_OR_FALSE]: "Вибрати брехня чи істина",
  [EExerciseType.SORT_WORDS]: "Відсортувати слова",
  [EExerciseType.MOVE_WORDS_INTO_GAPS]: "Перенести слова у пропуски",
  [EExerciseType.INPUT_WORDS_INTO_GAPS]: "Ввести слова у пропуски",
  [EExerciseType.CHOOSE_RIGHT_WORD_FORM]: "Вибрати правильну форму слова",
  [EExerciseType.MAKE_WORD_FROM_LETTERS]: "Скласти слово з літер",
  [EExerciseType.WORDS_COMPARING]: "Зіставлення слів",
  [EExerciseType.RECORD_AUDIO]: "Запис аудіо",
  [EExerciseType.COMPARE_IMAGE_WITH_DESCRIPTION]:
    "З'єднати слова та зображення",
};

export const Progress: React.FC = () => {
  const { data: courseProgress } = useStudentProgress();
  const { data: typeProgress } = useStudentProgressByType();

  return (
    <div className="nb-page-progress-container">
      <div className="nb-page-progress-wrapper">
        {courseProgress && courseProgress.length > 0 && (
          <section className="nb-page-progress-courses">
            {courseProgress.map((course) => {
              const percent =
                course.exerciseTotal > 0
                  ? Math.round(
                      (course.exerciseCompleted / course.exerciseTotal) * 100
                    )
                  : 0;
              return (
                <CircleProgress
                  key={course.courseId}
                  progress={percent}
                  centerText={course.courseName}
                  size={170}
                  centerTextSize="14px"
                />
              );
            })}
          </section>
        )}

        {typeProgress && typeProgress.length > 0 && (
          <section className="nb-page-progress-types">
            {typeProgress.map((item) => (
              <div key={item.type} className="nb-page-progress-type-tile">
                <span className="nb-page-progress-type-tile-count">
                  {item.exerciseCompleted}
                </span>
                <span className="nb-page-progress-type-tile-label">
                  {EXERCISE_TYPE_LABELS[item.type] ?? item.type}
                </span>
              </div>
            ))}
          </section>
        )}
      </div>
    </div>
  );
};
